var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.25 10a5.75 5.75 0 1 1 11.5 0v5.25h2.75a.75.75 0 0 1 0 1.5h-17a.75.75 0 0 1 0-1.5h2.75zm10 0v5.25h-8.5V10a4.25 4.25 0 0 1 8.5 0M12 19.25A2.25 2.25 0 0 1 9.75 17h-1.5a3.75 3.75 0 1 0 7.5 0h-1.5A2.25 2.25 0 0 1 12 19.25",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 3,
    r: 2,
    fill: "#FF6969"
  })));
};
export default SvgBell;